import { MyrAPIService } from '../../api/myr/myrAPI';

export function deleteAccountSvc(data, credentials) {
    return MyrAPIService.sendRequest(`member`, 'DELETE', data, credentials);
}
